try {
	maplibregl.prewarm();
} catch (e) {
	//
}